/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CityListResponse } from '../model';
// @ts-ignore
import { HotelCityNameDto } from '../model';
// @ts-ignore
import { HotelNearByCitiesResponse } from '../model';
/**
 * HotelCityApiApiHotelCityListGet - axios parameter creator
 * 
 * @summary Get City List (Id and PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelCityApiApiHotelCityListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/CityList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelCityApiApiHotelCityNameListGet - axios parameter creator
 * 
 * @summary Get City List (only PersianName)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelCityApiApiHotelCityNameListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/CityNameList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGet - axios parameter creator
 * 
 * @param {number} latitude 
 * @param {number} longitude 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetAxiosParamCreator (latitude: number, longitude: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'latitude' is not null or undefined
    assertParamExists('apiHotelLatitudeLongitudeNearByCitiesGet', 'latitude', latitude)
    // verify required parameter 'longitude' is not null or undefined
    assertParamExists('apiHotelLatitudeLongitudeNearByCitiesGet', 'longitude', longitude)
    const localVarPath = `/api/hotel/{latitude}/{longitude}/NearByCities`
        .replace(`{${"latitude"}}`, encodeURIComponent(String(latitude)))
        .replace(`{${"longitude"}}`, encodeURIComponent(String(longitude)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelLatitudeLongitudeNearByCitiesGet operation in HotelCityApi.
 * @export
 * @interface HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetRequest
 */
export interface HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGet
     */
    readonly latitude: number

    /**
     * 
     * @type {number}
     * @memberof HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGet
     */
    readonly longitude: number
}

/**
* 
* @summary Get City List (Id and PersianName)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelCityApiApiHotelCityListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelCityApiApiHotelCityListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<CityListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get City List (only PersianName)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelCityApiApiHotelCityNameListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelCityApiApiHotelCityNameListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<HotelCityNameDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGet(requestParameters: HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelCityApiApiHotelLatitudeLongitudeNearByCitiesGetAxiosParamCreator(requestParameters.latitude, requestParameters.longitude, options, configuration);
    const request: () => AxiosPromise<HotelNearByCitiesResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
